import { closeContextMenuSheet } from "./closeContextMenu";
import { OpenMenuResult } from "services/contextMenus/open";
import { AppContextMenuModel } from "models/view/contextMenu/AppContextMenuModel";

export function closeAllContextMenus(appMenus: AppContextMenuModel, result: OpenMenuResult): AppContextMenuModel {
    const { open } = appMenus;
    if (open) return closeContextMenuSheet(appMenus, open, result);
    else return appMenus;
}
